import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import app from "../firebase";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userRequest } from "../requestMethods";

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #000000a7;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const Wrapper = styled.div`
  padding: 18px 20px;
  width: 600px;
  gap: 20px;
  height: 200px;
  background-color: ${({ theme }) => theme.bgLighter};
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Close = styled.div`
  width: 30px;
  height: 30px;
  border: 1px solid ${({ theme }) => theme.text};
  border-radius: 50%;
  position: absolute;
  right: 10px;
  top: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.text};
  &:hover {
    background-color: crimson;
  }
`;

const Title = styled.h1`
  text-align: center;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 767px) {
    font-size: 18px;
  }
`;

const Input = styled.input`
  border: 1px solid ${({ theme }) => theme.soft};
  color: ${({ theme }) => theme.text};
  background-color: transparent;
  border-radius: 3px;
  padding: 10px;
`;

const Button = styled.button`
  border-radius: 3px;
  border: none;
  padding: 10px 20px;
  font-weight: 500;
  cursor: pointer;
  background-color: ${({ theme }) => theme.soft};
  color: ${({ theme }) => theme.textSoft};
`;

const Label = styled.label`
  font-size: 14px;
  color: ${({ theme }) => theme.text};
`;

const Perc = styled.span`
  color: ${({ theme }) => theme.text};
`;

const UploadImg = ({ setOpenImgModal, setOpenModal }) => {
  const navigate = useNavigate();
  const [img, setImg] = useState(undefined);
  const [imageUrl, setImageUrl] = useState(undefined);
  const [imgPerc, setImgPerc] = useState(0);
  const { currentUser } = useSelector((state) => state.user);

  const uploadFile = (file, urlType) => {
    const storage = getStorage(app);
    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        urlType === "img" && setImgPerc(Math.round(progress));

        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setImageUrl(downloadURL);
        });
      }
    );
  };
  useEffect(() => {
    img && uploadFile(img, "img");
  }, [img]);

  const handleUpload = async (e) => {
    e.preventDefault();
    await userRequest.put(`/users/${currentUser._id}`, { img: imageUrl });
    setOpenImgModal(false);
    setOpenModal(false);
    navigate("/");
  };
  console.log(imageUrl);
  return (
    <Container>
      <Wrapper>
        <Close
          onClick={() => {
            setOpenImgModal(false);
            document.body.style.overflow = "unset";
          }}
        >
          X
        </Close>
        <Title>Upload a New Image</Title>
        <Label>Image:</Label>
        {imgPerc > 0 ? (
       <Perc> Uploading: {imgPerc} %</Perc>
        ) : (
          <Input
            type="file"
            accept="image/*"
            onChange={(e) => setImg(e.target.files[0])}
          />
        )}
        {imgPerc === 100 && <Button onClick={handleUpload}>Upload</Button>}
      </Wrapper>
    </Container>
  );
};

export default UploadImg;
